export const USER_ROLE_SUPPLIER = 'supplier'
export const USER_ROLE_MANAGER = 'manager'
export const USER_ROLE_CUSTOMER = 'customer'
export const USER_ROLE_BOSS = 'boss'
export const USER_ROLE_SECUAZ = 'secuaz'
export const USER_ROLE_QUALITY = 'quality'
